import styled from 'styled-components';

export type RowProps = {
  /**
   * Рендер внутренних блоков c переносами
   */
  isWrap?: boolean;
  /**
   * Отступ между строками
   * Если число, берётся соответсвующий отступ из темы
   * Если строка, она напрямую используется для свойства `rowGap`
   */
  $rowGap?: string | number;
};

export const Row = styled.div<RowProps>(({
  isWrap,
  $rowGap,

  theme: {
    indents,
    grid,
  },
}) => ({
  display: 'flex',
  flexWrap: isWrap ? 'wrap' : undefined,
  marginLeft: -grid.COLS_INDENT_HALF,
  marginRight: -grid.COLS_INDENT_HALF,
  rowGap: $rowGap
    ? typeof $rowGap === 'number'
      ? indents[`INDENT_${$rowGap}` as keyof typeof indents]
      : $rowGap
    : undefined,
}));
